module.exports = __webpack_public_path__ + "0698baeda8db641c066324eb8e9b2dd4.otf";